import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'mat-cleaning-dialog',
    templateUrl: './cleaning-dialog.component.html',
    styleUrls: [ './cleaning-dialog.component.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CleaningDialogComponent implements OnInit {
    public timeLeft$: BehaviorSubject<number>;
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { time: number },
        private myDialogRef: MatDialogRef<CleaningDialogComponent>,
    ) {
    }

    public ngOnInit(): void {
        this.timeLeft$ = new BehaviorSubject<number>(this.data.time);
        const interval: NodeJS.Timeout = setInterval(() => {
            this.timeLeft$.next(this.timeLeft$.value - 1);
        }, 1000);
        setTimeout(() => {
            clearInterval(interval);
            this.myDialogRef.close();
        }, this.data.time * 1000);
    }
}
